import { render, staticRenderFns } from "./MessageTranslateDialog.vue?vue&type=template&id=07bfcbbc&scoped=true"
import script from "./MessageTranslateDialog.vue?vue&type=script&lang=js"
export * from "./MessageTranslateDialog.vue?vue&type=script&lang=js"
import style0 from "./MessageTranslateDialog.vue?vue&type=style&index=0&id=07bfcbbc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07bfcbbc",
  null
  
)

export default component.exports